/**
 * `label` names the state on its own — in the filter dropdown, in a tooltip.
 * `short` is for a row or a tile, where the column it sits in has already said
 * that this is a change state and repeating the word wastes the line.
 */
export const changeStateMeta: { [key: string]: { color: string; label: string; short: string } } = {
    ALL_CHANGES_COMPLETED: { color: 'green', label: 'All Changes Completed', short: 'Completed' },
    CHANGES_PENDING: { color: 'gold', label: 'Changes Pending', short: 'Pending' },
    CHANGES_APPROVED: { color: 'blue', label: 'Changes Approved', short: 'Approved' },
    CHANGES_REJECTED: { color: 'orange', label: 'Changes Rejected', short: 'Rejected' },
    CHANGES_ERRORED: { color: 'red', label: 'Error in Changes', short: 'Errored' },
};

export const runtimeStateOptions = [
    { value: 'IN_SERVICE', label: 'In Service' },
    { value: 'REQUESTED', label: 'Requested' },
    { value: 'DECOMMISSIONED', label: 'Decommissioned' },
];

export const changeStateOptions = Object.entries(changeStateMeta).map(([value, meta]) => ({
    value,
    label: meta.label,
}));

/**
 * No state among them. A state is something to filter the list down to, not to
 * order it by — the order would only ever be alphabetical, which says nothing
 * about how the states relate.
 */
export const sortOptions: { value: string; label: string; field: string; order: 'ASC' | 'DESC' }[] = [
    { value: 'id:DESC', label: 'Newest first', field: 'id', order: 'DESC' },
    { value: 'id:ASC', label: 'Oldest first', field: 'id', order: 'ASC' },
    { value: 'name:ASC', label: 'Name (A–Z)', field: 'name', order: 'ASC' },
    { value: 'name:DESC', label: 'Name (Z–A)', field: 'name', order: 'DESC' },
    { value: 'modified:DESC', label: 'Recently modified', field: 'modified', order: 'DESC' },
];

export const DEPENDANT_INFO =
    'Dependant service items are items owned by other teams that your services rely on. ' +
    'They are read-only here — toggle this on to review what your services depend upon.';
